import React from 'react'
import './Sistema.css'

const Sistema = () => {
  return (
    <main className="sistemaPage">
      <section className="sistemaCard">
        <h1>Sistema ASJF</h1>
        <p>
          Este espaço está temporariamente em manutenção. Em breve serão disponibilizadas
          novas informações e acessos para associados.
        </p>
        <div className="sistemaInfo">
          <span>Em manutenção</span>

        </div>
      </section>
    </main>
  )
}

export default Sistema
